<template>
    <div class="t-mainPageHolder">
        <div class="t-mainPageCarousel">
            <Carousel :slides="slides" :slidesL="slidesL"></Carousel>
        </div>
        <div class="t-container">
            <section class="t-mainCard t-aboutCompany t-js-animate">
                <div class="t-mainSidesHolder">
                    <div class="t-leftSide">
                        <h2 class="t-mainTitle">Об организации</h2>
                        <div class="t-textHolder">
                            <p>Региональная общественная организация людей с инвалидностью «Перспектива» создана в 1997 г. На сегодняшний день мы — одна из ведущих организаций, отстаивающих права людей с инвалидностью в России.
                                <br>
                                <br>
                                Сотрудничая с государственными структурами, коммерческими и некоммерческими организациями, предоставляя услуги людям с инвалидностью, мы способствуем:
                            </p>
                        </div>
                        <ul class="t-mainList">
                            <li>Преодолению физических и психологических барьеров,  существующих в обществе по отношению к людям с инвалидностью.</li>
                            <li>Содействию людям с инвалидностью и их семьям в приобретении навыков  и знаний, необходимых для полноправного участия в жизни общества</li>
                            <li>Повышению эффективности работы  общественных организаций людей с инвалидностью.</li>
                        </ul>
                    </div>
                    <div class="t-rightSide">
                        <h4 class="t-middleTitle">Новости</h4>
                        <div class="t-newsCardsHolder">
                            <div v-if="loading" style="text-align: center">Загрузка</div>
                            <news-card :news="item" v-for="(item, index) in two" :key="index" v-else></news-card>
                        </div>
                        <router-link tag="div" :to="'/news'" class="t-watchAll">
                            <span>Смотреть все</span>
                            <svg width="26" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7h24m0 0l-8.308-6M25 7l-8.308 6" stroke="#4085D5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </router-link>
                    </div>
                </div>
            </section>
            <section class="t-mainCard t-numbersAndCount t-js-animate">
                <div class="t-leftSide">
                    <h2 class="t-mainTitle">Цифры и факты</h2>
                    <div class="t-numberCardsHolder">
                        <div class="t-numberCard" v-for="item in numbersOutput">
                            <div class="t-numberCardCountWrapper">
                                <h2 class="t-numberCardCount">{{ item.count }}</h2>
                            </div>
                            <div class="t-numberCardTextWrapper">
                                <p>{{ item.msg }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="t-rightSide">
                    <h4 class="t-middleTitle">Фотолента</h4>
                    <div class="t-lightBoxWrapper">
                        <gallery :tape="tape" :le="le"></gallery>
                    </div>
                </div>
            </section>
            <section class="t-mainCard t-ourPrinciples t-js-animate">
                <h2 class="t-mainTitle">Наши принципы</h2>
                <div class="t-principlesCardHolder">
                    <div class="t-principlesCard" v-for="(item, index) in principles">
                        <div class="t-principlesCardNumber"><span>{{ index+1 }}</span></div>
                        <div class="t-principlesCardText">
                            <p>{{ item.msg }}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Carousel from './Carousel.vue';
    import { store } from '../../store';
    import { mapGetters, mapActions } from 'vuex';
    export default {
        data() {
          return {
              pathToNumbers: '/JSON/info.json',
              pathToJson: '/JSON/principles.json',
              numbersOutput: [],
              principles: [],
          }
        },
        components: {
            Carousel: Carousel
        },
        computed: {
            loading() {return this.$store.getters.loading},
            ...mapGetters('tape', {
                tape: 'loadedTape',
                le: 'returnTapeLength'
            }),
            ...mapGetters('two', {
                two: 'loadedTwo'
            }),
            ...mapGetters('slides', {
                slides: 'loadedSlides',
                slidesL: 'loadedSlidesLength'
            }),
        },
        methods: {
            getNumbersInfo() {
                this.$http.get(this.pathToNumbers)
                    .then(response => response.json())
                    .then(json => {
                        this.numbersOutput = json;
                    }, error => {
                        console.error(error);
                    });
            },
            getTextForPrinciples() {
                this.$http.get(this.pathToJson)
                    .then(response => response.json())
                    .then(json => {
                            this.principles = json;
                    }, error => {
                        console.error(error);
                    });
            },
        },
        created() {
            this.getNumbersInfo();
            this.getTextForPrinciples();

            function isScrolledIntoView(container) {
                var elementPosition = {
                        top: window.pageYOffset + container.getBoundingClientRect().top,
                        bottom: window.pageYOffset + container.getBoundingClientRect().bottom
                    },
                    windowPosition = {
                        top: window.pageYOffset,
                        bottom: window.pageYOffset + document.documentElement.clientHeight
                    };
                return (
                    elementPosition.bottom > windowPosition.top &&
                    elementPosition.top < windowPosition.bottom 
                );
            }

            window.addEventListener('scroll', function() {
                document.querySelectorAll('.t-js-animate:not(.animated)').forEach(item => {
                    if (isScrolledIntoView(item) === true) {
                        item.classList.add('animated')
                        let timer=[];
                        item.querySelectorAll('.t-numberCardCount').forEach( (count, index) => {
                            let last = parseInt(count.textContent);
                            let step = parseInt(last/20);
                            let start = 0
                            count.textContent = start;
                            timer[index] = setInterval(function () {
                                let now = parseInt(count.textContent);
                                count.textContent = 0 + now + step;
                                if (now >= last) {
                                    count.textContent=last
                                    clearInterval(timer[index]);
                                }
                            }, 50);
                        })
                    }
                });
            });
        },

        beforeRouteEnter (to, from, next) {
            Vue.http.get('/api/tape.json')
                .then(response => response.json())
                .then(data => {
                    store.dispatch('tape/loadTape', data);
                })
                .then(
                    Vue.http.get('/api/news-two.json')
                        .then(response => response.json())
                        .then(data => {
                            store.dispatch('two/loadTwo', data)
                        })
                )
                .then(Vue.http.get('/api/slider.json')
                    .then(response => response.json())
                    .then(data => {
                        next(store.dispatch('slides/loadSlides', data))
                    })
                )
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/vue_components/Page/Index.vue